import { hasAccessToken } from './token';

export const TEMPORARY_SESSION_STORAGE_KEY = 'temporary_session';

export function hasActiveSession() {
  return hasAccessToken();
}

export function isUserLoggedIn(account) {
  return (hasActiveSession() && Boolean(account && account.id));
}
